import { render } from "./CompaniesList.vue?vue&type=template&id=6b3d5d30"
import script from "./CompaniesList.vue?vue&type=script&lang=js"
export * from "./CompaniesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/Companies/CompaniesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b3d5d30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b3d5d30', __exports__)) {
    api.reload('6b3d5d30', __exports__)
  }
  
  module.hot.accept("./CompaniesList.vue?vue&type=template&id=6b3d5d30", () => {
    api.rerender('6b3d5d30', render)
  })

}


export default __exports__